export const es = {
  'LOCALE.SITE.TTILE': 'Deadly Arcade',
  'LOCALE.FLIPERAMA': 'Ilustración de la pantalla de un fliperama',
  'LOCALE.GAME': 'Jugar',
  'LOCALE.CHARACTERES': 'Personajes',
  'LOCALE.VIDEO': 'Trailer',
  'LOCALE.RANKING': 'Clasificación',
  'LOCALE.SOCIAL': 'Social',
  'LOCALE.SOUNDTRACK': 'Banda sonora',
  'LOCALE.SCREENSHOTS': 'Capturas',

  'LOCALE.VIDEO.TEXT':
    '¿Te gustó el juego? Ahora mira el tráiler, conoce mucho más de Deady Class.',
  'LOCALE.VIDEO.BTN': 'Ilustración de un botón de TV',

  'LOCALE.GAME.BEST_SCORE': 'Mejor puntuación',

  'LOCALE.RANKING.HEADER.NAME': 'Nombre',
  'LOCALE.RANKING.HEADER.COUNTRY': 'País',
  'LOCALE.RANKING.HEADER.SCORE': 'Puntos',
  'LOCALE.RANKING.PLACEHOLDER': 'No hay registro',

  'LOCALE.SHARE.WHATSAPP': 'Compartir en Whatsapp',
  'LOCALE.SHARE.FACEBOOK': 'Compartir en Facebook',
  'LOCALE.SHARE.TWITTER': 'Compartir en Twitter',

  'LOCALE.SOUNDTRACK.PLAY': 'Iniciar sonido',
  'LOCALE.SOUNDTRACK.PAUSE': 'Pausar sonido',
  'LOCALE.SOUNDTRACK.CHOOSE': 'Seleccione un sonido',
  'LOCALE.SOUNDTRACK.THEME': 'Deadly Arcade',
  'LOCALE.SOUNDTRACK.CARTOON': 'Fans Papelitos',
  'LOCALE.SOUNDTRACK.MEDIEVAL': 'Fans Heladitos',
  'LOCALE.SOUNDTRACK.TERROR': 'Fans Raritos',
  'LOCALE.SOUNDTRACK.ZOMBIE': 'Fans Muertitos',

  'LOCALE.SOUNDTRACK.BUTTON.THEME': 'Seleccionar música Deadly Arcade',
  'LOCALE.SOUNDTRACK.BUTTON.CARTOON': 'Seleccionar música Fans Papelitos',
  'LOCALE.SOUNDTRACK.BUTTON.MEDIEVAL': 'Seleccionar música Fans Heladitos',
  'LOCALE.SOUNDTRACK.BUTTON.TERROR': 'Seleccionar música Fans Raritos',
  'LOCALE.SOUNDTRACK.BUTTON.ZOMBIE': 'Seleccionar música Fans Muertitos',

  'LOCALE.IOC.ARG': 'Argentina',
  'LOCALE.IOC.BOL': 'Bolivia',
  'LOCALE.IOC.BRA': 'Brasil',
  'LOCALE.IOC.CHI': 'Chile',
  'LOCALE.IOC.COL': 'Colombia',
  'LOCALE.IOC.CRC': 'Costa Rica',
  'LOCALE.IOC.CUB': 'Cuba',
  'LOCALE.IOC.ESA': 'El Salvador',
  'LOCALE.IOC.ECU': 'Ecuador',
  'LOCALE.IOC.GUA': 'Guatemala',
  'LOCALE.IOC.HAI': 'Haiti',
  'LOCALE.IOC.HON': 'Honduras',
  'LOCALE.IOC.MEX': 'México',
  'LOCALE.IOC.UNK': 'El mundo',
  'LOCALE.IOC.NCA': 'Nicaragua',
  'LOCALE.IOC.PAN': 'Panamá',
  'LOCALE.IOC.PAR': 'Paraguay',
  'LOCALE.IOC.PER': 'Perú',
  'LOCALE.IOC.DOM': 'República Dominicana',
  'LOCALE.IOC.URU': 'Uruguay',
  'LOCALE.IOC.VEN': 'Venezuela',

  'LOCALE.ACCESSIBILITY.MARCUS.TITLE': 'Acerca de Marcus Lopez',
  'LOCALE.ACCESSIBILITY.MARCUS.ALTERNATIVE_IMAGE_DATA':
    'Ilustración de Marcus Lopez',
  'LOCALE.ACCESSIBILITY.MARCUS.BUTTON': 'Seleccionar personaje Marcus Lopez',

  'LOCALE.ACCESSIBILITY.SAYA.TITLE': 'Acerca de Saya',
  'LOCALE.ACCESSIBILITY.SAYA.ALTERNATIVE_IMAGE_DATA': 'Ilustración de Saya',
  'LOCALE.ACCESSIBILITY.SAYA.BUTTON': 'Seleccionar personaje Saya',

  'LOCALE.ACCESSIBILITY.BILLY.TITLE': 'Acerca de Billy',
  'LOCALE.ACCESSIBILITY.BILLY.ALTERNATIVE_IMAGE_DATA': 'Ilustración de Billy',
  'LOCALE.ACCESSIBILITY.BILLY.BUTTON': 'Seleccionar personaje Billy',

  'LOCALE.ACCESSIBILITY.MARIA.TITLE': 'Acerca de Maria',
  'LOCALE.ACCESSIBILITY.MARIA.ALTERNATIVE_IMAGE_DATA': 'Ilustración de Maria',
  'LOCALE.ACCESSIBILITY.MARIA.BUTTON': 'Seleccionar personaje Maria',

  'LOCALE.ACCESSIBILITY.MASTER.TITLE': 'Acerca de Master Lin',
  'LOCALE.ACCESSIBILITY.MASTER.ALTERNATIVE_IMAGE_DATA':
    'Ilustración de Master Lin',
  'LOCALE.ACCESSIBILITY.MASTER.BUTTON': 'Seleccionar personaje Master Lin',

  'LOCALE.ACCESSIBILITY.SCREENSHOT.1': 'Captura de gameplay 1',
  'LOCALE.ACCESSIBILITY.SCREENSHOT.2': 'Captura de gameplay 2',
  'LOCALE.ACCESSIBILITY.SCREENSHOT.3': 'Captura de gameplay 3',
  'LOCALE.ACCESSIBILITY.SCREENSHOT.4': 'Captura de gameplay 4',
  'LOCALE.ACCESSIBILITY.SCREENSHOT.5': 'Captura de gameplay 5',
  'LOCALE.ACCESSIBILITY.SCREENSHOT.6': 'Captura de gameplay 6',

  'LOCALE.LIGHTBOX.CLOSE': 'Dejar',
  'LOCALE.LIGHTBOX.BACK': 'Regresar una captura',
  'LOCALE.LIGHTBOX.NEXT': 'Ir a siguiente captura',

  'LOCALE.COUNTRY.PLACEHOLDER': 'Seleccionar país',
  'LOCALE.SCREENSHOT.PLACEHOLDER': 'Seleccionar captura',

  'LOCALE.MARCUS.DESCRIPTION': `
    Marcus es el protagonista de Deadly Class. Un huérfano acusado de iniciar el incendio de su orfanato, donde murieron 12 niños. Es el nuevo de King’s Dominion. Su arma preferida es el bate.
    `,

  'LOCALE.MARIA.DESCRIPTION': `
    Fue criada y entrenada para matar por un cartel de narcotraficantes que asesinó a sus padres. Luego fue inscrita en King´s Dominion. El arma que utiliza es el abanico.
    `,

  'LOCALE.BILLY.DESCRIPTION': `
    Su padre es contrabandista y lo inscribió en King’s Dominion para endurecer su carácter. Tienen mala relación, por eso buscará ayuda para matarlo. Es divertido y amigable. Le gusta patinar.
    `,

  'LOCALE.SAYA.DESCRIPTION': `
    Estudiante destacada de King’s Dominion. De origen japonés, su padre era miembro de los Yakusa, pero huyó de ellos viajando a USA. Su arma preferida es la Katana.
    `,

  'LOCALE.MASTER.DESCRIPTION': `
    Sabio director de King’s Dominion. Entrena a “solucionadores creativos de problemas”. El que le dio la oportunidad a Marcus, de entrar a su escuela. No acepta gente débil.
    `,

  'LOCALE.ACCESSIBILITY.SCROLL_TO_BOTTOM': 'Ver más',

  'LOCALE.FX.URL': 'https://foxplay.com/mx/show/FNGTVSeriesP6263',
  'LOCALE.FX.LABEL': 'Acesso a Fox',
};
